import { Text, Heading, NakedButton } from 'roo-ui/components';
import { Link } from 'components/Typography';
import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import { hideVisually } from 'polished';

export const BackLink = styled(Link)`
  display: flex;
  align-items: center;
  color: white;
  :hover {
    color: white;
    opacity: 0.8;
  }
`;

export const PageTitle = styled(Heading.h1)<{ hideOnMobile: boolean }>`
  margin: 0;
  line-height: 1.5;
  display: block;
  white-space: nowrap;
  color: ${themeGet('colors.white')};

  font-size: ${themeGet('fontSizes.xl')};
  font-weight: ${themeGet('fontWeights.normal')};

  /* Visually hide title on mobile */
  ${themeGet('mediaQueriesMaxWidth.0')} {
    ${(props) => (props.hideOnMobile ? hideVisually() : undefined)}
  }

  ${themeGet('mediaQueries.0')} {
    font-size: ${themeGet('fontSizes.4xl')};
    line-height: 1;
  }
`;

export const CloseButton = styled(NakedButton)`
  display: flex;
  white-space: nowrap;
  align-items: center;
  align-self: flex-start;
  line-height: 0;

  color: ${themeGet('colors.white')};
  font-size: ${themeGet('fontSizes.base')};
`;

export const UppercaseText = styled(Text)`
  text-transform: uppercase;
`;
